<template>
  <div class="review-maps" ref="reviewMapsBox">
    <span class="back" @click="goBack"></span>
    <VerticalScrollbox v-if="!showLoading" :ready="isReady" :width="mapWidth">
      <div class="ver-scroll-list" v-if="mapBgList.length > 0">
        <img
          @dragstart.prevent="dragstart"
          class="map-bg"
          :src="item"
          v-for="(item, index) in mapBgList"
          :key="index"
          alt
        />

        <div
          v-if="canLoadMore"
          v-show="isScaleOver"
          class="ver-scroll-mask"
          :style="{ width: mapWidth + 'px' }"
        >
          <template v-for="(mapitem, mapindex) in mapItemList">
            <!-- 关卡 是否 禁用 -->
            <template v-if="mapitem.steps_isenabled != 1">
              <!-- 是否 拥有 权限 -->
              <template v-if="mapitem.steps_run == 1">
                <div
                  :key="`${mapindex}${Math.random()}`"
                  :style="{
                    top: `${mapitem.coordinate.y * 100}%`,
                    left: `${mapitem.coordinate.x * 100}%`,
                    width: `${mapitem.width}px`,
                    height: `${mapitem.height}px`,
                  }"
                  class="map-item"
                >
                  <img
                    @click="chooseSteps(mapitem)"
                    @dragstart.prevent="dragstart"
                    :src="mapitem.image"
                    alt
                  />
                </div>
              </template>
              <template v-else>
                <div
                  :key="`${mapindex}${Math.random()}`"
                  :style="{
                    top: `${mapitem.coordinate.y * 100}%`,
                    left: `${mapitem.coordinate.x * 100}%`,
                    width: `${mapitem.width}px`,
                    height: `${mapitem.height}px`,
                    opacity: '.4',
                  }"
                  class="map-item"
                >
                  <img
                    @dragstart.prevent="dragstart"
                    :src="mapitem.image"
                    alt
                  />
                </div>
              </template>
            </template>
          </template>
        </div>
      </div>
    </VerticalScrollbox>
    <PageLoading :active="showLoading" />
    <pop-tips
      @handConfirm="handConfirm"
      @handleCloseTip="handleCloseTip"
      :dialogVisable="dialogVisable"
      :popTipsCont="popTipsCont"
    ></pop-tips>
  </div>
</template>
<script>
import PopTips from "@/components/popTips";

import ReviewHttp from "./review";
import CommonHttp from "@/utils/http";
import VerticalScrollbox from "@/components/VerticalScrollbox";
import PageLoading from "@/components/Loading";

const BG_INIT_HEIGHT = 1024; // 背景图 默认之 1024px 高度
export default {
  name: "review-map",
  data() {
    return {
      mapBgList: [], // 地图 背景
      mapItemList: [], // 地图 关卡位置 信息
      loadcount: 0, // 背景加载个数
      mapItemCount: 0, // 关卡加载个数
      mapWidth: 0,
      mapHeight: 0,
      scale: 1, // 根据 屏幕 缩放比例
      showLoading: false,
      isScaleOver: false,
      canLoadMore: false,
      isReady: false,
      dialogVisable: false,
      popTipsCont: {
        title: this.$t("Common.tips"),
        context: this.$t("blendType.load"),
        btns: [
          {
            text: this.$t("Common.confirm"),
            event: "handConfirm",
          },
        ],
      },
      stepsList: [], // 关卡数组
    };
  },
  components: {
    VerticalScrollbox,
    PageLoading,
    PopTips,
  },
  created() {
    // this.$route.meta.keepAlive = true
    this.student_id = this.$store.state.currentChild.student_id;
    this.id = this.$route.query.id;
    this.getMapsResource(this.id);
    this.getGoldTotaling();
    this.showLoading = true;
  },
  mounted() {
    let height = this.$refs["reviewMapsBox"].offsetHeight;
    this.mapHeight = height;
    this.scale = this.mapHeight / BG_INIT_HEIGHT;
  },
  watch: {
    mapBgList(n) {
      if (n.length > 0) {
        n.forEach((element) => {
          let img = new Image();
          // img.src = `${element}?time=${new Date().getTime()}`;
          img.src = `${element}`;
          img.onload = () => {
            ++this.loadcount;
            this.mapWidth += img.width * this.scale;
          };
        });
      }
    },
    mapItemCount(n) {
      console.log(n, this.mapItemList.length);
      if (n == this.mapItemList.length) {
        this.$forceUpdate();
        this.isScaleOver = true;
        this.showLoading = false;
      }
    },
    loadcount(n) {
      if (n == this.mapBgList.length) {
        this.canLoadMore = true;
        this.isReady = true;
      }
    },
  },
  activated() {
    let verlist = document.getElementsByClassName("ver-scroll-list");
    if (verlist.length) {
      verlist[0].style["pointer-events"] = "";
    }

    if (this.$route.meta.canUpdate) {
      this.showLoading = true;
      window.location.reload();
    }
  },
  deactivated() {
    console.log("deactivated");
  },
  beforeRouteEnter(to, from, next) {
    // if (from.path == 'Review/ReviewList') {
    //   to.meta.keepAlive = true
    // } else {
    //   to.meta.keepAlive = false
    // }
    next();
  },
  beforeRouteLeave(to, from, next) {
    // if (to.path == '/Review/ReviewQuestions') {
    //   from.meta.keepAlive = true
    // } else {
    //   from.meta.keepAlive = false
    // }
    next();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    dragstart() {
      return false;
    },
    // 背景图 加载
    loadImg(i) {
      var img = new Image();
      // img.src = `${this.mapItemList[i].image}?time=${new Date().getTime()}`;
      img.src = `${this.mapItemList[i].image}`;
      img.onload = () => {
        ++this.mapItemCount;
        this.mapItemList[i]["width"] = img.width * this.scale;
        this.mapItemList[i]["height"] = img.height * this.scale;
      };
    },
    // 获取 关卡资源
    getMapsSteps(maps_id) {
      ReviewHttp.getMapsSteps({
        member_id: this.$store.state.member_id,
        token: this.$store.state.token,
        student_id: this.student_id,
        maps_id,
      }).then((res) => {
        const { error, result } = res.data;
        if (error == 0) {
          this.stepsList = result.list;

          this.mapItemList.forEach((e1, i1) => {
            this.loadImg(i1);
            this.stepsList.forEach((e2, i2) => {
              if (e1.key == e2.steps_key) {
                this.mapItemList[i1].steps_isenabled = e2.steps_isenabled;
                this.mapItemList[i1].steps_run = e2.steps_run;
                this.mapItemList[i1].steps_id = e2.steps_id;
                this.mapItemList[i1].steps_title = e2.steps_title;
                this.mapItemList[i1].games_id = e2.games_id;
                this.mapItemList[i1].games_url = e2.games_url;
              }
            });
          });
        } else {
          this.stepsList = [];
        }
      });
    },
    handConfirm() {
      this.dialogVisable = false;
    },
    handleCloseTip() {
      this.dialogVisable = false;
    },
    // 选择 关卡
    chooseSteps(item) {
      console.log(item);
      // if (item.games_id == 3) {
      //   window.location = `https://stupc.kidcastle.cn/game/saiche/?member_id=${this.$store.state.member_id}&token=${this.$store.state.token}&student_id=${this.student_id}&steps_id=${item.steps_id}`;
      // } else if (item.games_id != 0) {
      //   this.dialogVisable = true;
      // } else {
      //   this.$router.push({
      //     path: `/Review/ReviewQuestions?id=${item.steps_id}&title=${item.steps_title}&from=review`
      //   });
      // }
      if (item.games_id != 0) {
        if (item.games_url == "false") {
          this.dialogVisable = true;
        } else {
          if (item.games_id == -1) {
            this.getMapsStepsMedias(item.steps_id).then((res) => {
              if (res.status == "ok") {
                window.location.href = res.data.steps_outurl;
              }
            });
          } else {
            window.location.href = `${item.games_url}?member_id=${this.$store.state.member_id}&token=${this.$store.state.token}&student_id=${this.student_id}&steps_id=${item.steps_id}&from=map`;
          }
          // window.open(`${item.games_url}?member_id=${this.$store.state.member_id}&token=${this.$store.state.token}&student_id=${this.student_id}&steps_id=${item.steps_id}`)
        }
      } else {
        this.$router.push({
          path: `/Review/ReviewQuestions?id=${
            item.steps_id
          }&title=${item.steps_title.replace(/&/g, " And ")}&from=review`,
        });
      }
    },
    getMapsStepsMedias(steps_id) {
      return new Promise((resove) => {
        ReviewHttp.getMapsStepsMedias({
          member_id: this.$store.state.member_id,
          token: this.$store.state.token,
          student_id: this.student_id,
          steps_id,
        }).then((res) => {
          const { error, result } = res.data;
          if (error == 0) {
            resove({
              status: "ok",
              data: result.list,
            });
          }
        });
      });
    },
    // 获取 地图资源
    getMapsResource(maps_id) {
      ReviewHttp.getMapsResource({
        member_id: this.$store.state.member_id,
        token: this.$store.state.token,
        student_id: this.student_id,
        maps_id,
      }).then((res) => {
        this.getMapsSteps(this.id);
        const { result } = res.data;
        if (res.data.error == 0) {
          this.mapBgList = result.list.bkg_images;
          this.mapItemList = result.list.steps;
        } else {
          this.mapBgList = [];
          this.mapItemList = [];
        }
      });
    },
    // 获取 金币
    getGoldTotaling() {
      CommonHttp.getGoldTotaling({
        member_id: this.$store.state.member_id,
        token: this.$store.state.token,
        student_id: this.student_id,
        timestamp: new Date().getTime(),
      }).then((res) => {
        const { error, result } = res.data;
        if (error == 0) {
          let childInfo = this.$store.state.currentChild;
          childInfo.student_goldprice = result.goldprice;
          this.$Tool.setStorage("currentStuInfo", childInfo);
          this.$store.dispatch("setCurrentChild", childInfo);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.review-maps {
  margin-top: 20px;
  height: calc(100% - 100px);
  -webkit-user-select: none;
  position: relative;
  & > .back {
    width: 40px;
    height: 43px;
    position: absolute;
    top: 20px;
    left: 20px;
    background: url(../../../assets/images/back-icon.png) center center
      no-repeat;
    background-size: cover;
    z-index: 1000;
    cursor: pointer;
  }
  .ver-scroll-list {
    display: flex;
    height: 100%;
    position: relative;
    .ver-scroll-mask {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
    }
    .map-bg {
      height: 100%;
    }

    .map-item {
      position: absolute;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
